module.exports = __webpack_public_path__ + "img/banner.d0546eb4.png";